import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTopAuto from "../lib/Components/ScrollToTopAuto";
// import loadable from '@loadable/component'
import Header from "../lib/Components/Header";
import Footer from "../lib/Components/Footer";

// Routes
import Page from "./page";
import Home from "./Home";
import BlogPage from "./blog";
import PostPage from "./post";
import Favorites from "./favorites";
import Quote from "./quote";
import TechnicalFiles from "./technical-files";
import SearchResults from "./results/[keyword]";
import ProductGroup from "./product-group/[taxonomy]";
import ProductDetail from "./product/[slug]";
import NoMatch from "./page/404";

export default function QuamRouter() {
  return (
    <Router>
      <ScrollToTopAuto />
      <Header />
      <Routes>
        {/* Custom WP Pages */}
        <Route path="/page/:slug" element={<Page />} />

        {/* Product Group Pages */}
        <Route path="/product-group/:taxonomy" element={<ProductGroup />} />

        {/* Product Detail Pages */}
        <Route path="/product/:slug" element={<ProductDetail />} />

        {/* Tech Files Page */}
        <Route path="/technical-files" element={<TechnicalFiles />} />

        {/* Favorites Page */}
        <Route path="/favorites" element={<Favorites />} />

        {/* Quote Page */}
        <Route path="/quote" element={<Quote  />} />

        {/* Search Results Page */}
        <Route path="/results/:keyword" element={<SearchResults />} />

        <Route path="/blog" element={<BlogPage />} />

        <Route path="/post/:slug" element={<PostPage />} />

        {/* Home Page */}
        <Route path="/" element={<Home />} />

        {/* 404 Catch-All Page */}
        <Route path="*" element={<NoMatch />} />
      </Routes>
      <Footer />
    </Router>
  );
}
